import React from 'react';
import { Box } from '@mui/material';
import '@trp-beacon-ui-kit/foundation/css/style.css';

import ErrorIcon from '../assets/images/Error_Icon.svg';


export default function GenericError({ title = 'Sorry, something went wrong', children, id }) {
    return (
        <Box
            id='error-page-container'
            className='beacon-theme-modern-outlook beacon-on-light'
            sx={{

            }}
        >
            <Box pb='12px' id='error-img-container'>
                <img src={ErrorIcon} alt="loading-error" id={`${id}-error-img}`} />
            </Box>
            <Box pb='16px' className='b-typography-serif--headline-loose--400 b-font-weight-bold' id={`${id}-error-title`}>
                {title}
            </Box>
            <Box className='b-typography-sans-serif--body--200 b-font-weight-light' id={`${id}-error-message`}>
                {children}
            </Box>
        </Box>
    );
}
